module.exports = __webpack_public_path__ + "img/button_delete_anots.65230847.svg";